module.exports = __webpack_public_path__ + "img/76bb6e7f4dd86449723054232befb5b9.png";